import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { ClockIcon } from '@moia-dev/pace-icons'
import { ServiceHoursAreaRoutes } from './ServiceHoursAreaRoutes'

export const ServiceHoursAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={ServiceHoursAreaRoutes.route}
      Icon={ClockIcon}
    />
  )
}
